import { ModuleComponent } from "../../js/module-component";

export class ModFaqs extends ModuleComponent {
    ready() {
        super.ready();
        this.findMember("faq-link").click((ev) => {
            ev.preventDefault();
            $(ev.currentTarget).closest(this.scope+"__faq").toggleClass("is-opened").siblings().removeClass("is-opened");
        });
    }
}
